export const ADD = "saleOrdersCart/ADD";
export const REMOVE = "saleOrdersCart/REMOVE";
export const SET_ALL = "saleOrdersCart/SET_ALL";



// WEBPACK FOOTER //
// ./app/Nav/SaleOrdersCart/actionTypes.js